import {
  ExternalPayoutStatus,
  IPayoutInfluencer,
} from "@shared/lib/types/briefCampains";
import { getPayoutInfluencerBankDetails } from "../../lib/getVerifiedBankDetails";
import {
  getExternalPayoutStatusLabel,
  getExternalPayoutStatusTone,
  getPayoutUtr,
  maskAccountNumber,
} from "../../lib/payoutDisplay";
import styles from "./styles.module.scss";

type PayoutStatusCellProps = {
  record: IPayoutInfluencer;
};

export function PayoutStatusCell({ record }: PayoutStatusCellProps) {
  const status = record.externalPayoutStatus;
  const tone = getExternalPayoutStatusTone(status);
  const utr = getPayoutUtr(record);
  const reason = record.externalPayoutRejectionReason;
  const bank = getPayoutInfluencerBankDetails(record);
  const showBank =
    status !== ExternalPayoutStatus.Pending &&
    status !== ExternalPayoutStatus.Cancelled &&
    Boolean(bank);

  return (
    <div className={styles.cell}>
      <span className={`${styles.pill} ${styles[tone]}`}>
        {getExternalPayoutStatusLabel(status)}
      </span>
      {utr ? <div className={styles.meta}>UTR {utr}</div> : null}
      {status === ExternalPayoutStatus.Failed && reason ? (
        <div className={styles.reason}>{reason}</div>
      ) : null}
      {status === ExternalPayoutStatus.Cancelled && reason ? (
        <div className={styles.reason}>{reason}</div>
      ) : null}
      {showBank && bank ? (
        <div className={styles.bank}>
          {bank.bankName ? `${bank.bankName} · ` : ""}
          {maskAccountNumber(bank.accountNumber)}
        </div>
      ) : null}
    </div>
  );
}
